// @flow

import React, { type Element } from 'react';
import styled from 'styled-components';

import { FONT_WEIGHT_100 } from '../../styles/font-weight';
import { TYPE_SCALE_F6 } from '../../styles/type-scale';
import { SPACING_SMALL, SPACING_MEDIUM } from '../../styles/spacing';
import { CLARK_TERTIARY } from '../../styles/colors';
import { BORDER_WIDTH_1 } from '../../styles/borders';

type PropsType = {
  copy: string,
  link: string,
  icon?: Element<*>,
  className?: string,
};

const FaqLink = ({ className, copy, link, icon }: PropsType) => (
  <Container className={className}>
    {icon && <Icon>{icon}</Icon>}
    <Link target="_blank" href={link}>
      {copy}
    </Link>
  </Container>
);

export default FaqLink;

const Container = styled.div`
  ${TYPE_SCALE_F6};
  display: flex;
  align-items: center;
`;

const Link = styled.a`
  ${FONT_WEIGHT_100};
  border-bottom: ${BORDER_WIDTH_1} dotted ${CLARK_TERTIARY};
  color: ${CLARK_TERTIARY};
  text-decoration: none;
`;

const Icon = styled.div`
  color: ${CLARK_TERTIARY};
  height: ${SPACING_MEDIUM};
  margin-right: ${SPACING_SMALL};
  width: ${SPACING_MEDIUM};
`;



// WEBPACK FOOTER //
// ./src/components/faq-link/index.js